import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
const CRITEO_ACCOUNT_ID = 125675;

/**
 * 디바이스 타입 감지
 * @returns 'd' (desktop) | 't' (tablet) | 'm' (mobile)
 */
const getDeviceType = () => {
  const ua = navigator.userAgent;
  if (/iPad/.test(ua)) return 't';
  if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(ua)) return 'm';
  return 'd';
};
export const useCriteoTracker = () => {
  const $ = _c(1);
  const initScript = _temp;
  const trackTransaction = _temp2;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      initScript,
      trackTransaction
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
function _temp() {
  if (typeof document === "undefined") {
    return;
  }
  if (document.getElementById("criteo-loader-script")) {
    return;
  }
  const script = document.createElement("script");
  script.id = "criteo-loader-script";
  script.src = `//dynamic.criteo.com/js/ld/ld.js?a=${CRITEO_ACCOUNT_ID}`;
  script.async = true;
  script.type = "text/javascript";
  document.head.appendChild(script);
  window.criteo_q = window.criteo_q || [];
  window.criteo_q.push({
    event: "setAccount",
    account: CRITEO_ACCOUNT_ID
  }, {
    event: "setSiteType",
    type: getDeviceType()
  }, {
    event: "viewHome"
  });
}
function _temp2(transactionId) {
  if (typeof window === "undefined") {
    return;
  }
  window.criteo_q = window.criteo_q || [];
  window.criteo_q.push({
    event: "setAccount",
    account: CRITEO_ACCOUNT_ID
  }, {
    event: "setSiteType",
    type: getDeviceType()
  }, {
    event: "trackTransaction",
    id: transactionId,
    item: [{
      id: "1",
      price: 1,
      quantity: 1
    }]
  });
}